<nav mat-tab-nav-bar class="collected-data" *ngIf="router.url.includes('default')" [tabPanel]="tabPanel"></nav>

<mat-tab-nav-panel #tabPanel>
    <!-- Contenu des onglets ici -->
  </mat-tab-nav-panel>